//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export default {
  name: 'PDPCommentUserProfile',
  props: {
    comment: {
      type: Object,
      default: () => ({}),
    },
    commenterIsDealPartner: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    parseFormatTime(date, format) {
      if (!date) return '';

      if (typeof date === 'number') {
        return dayjs.unix(date).tz(dayjs.tz.guess()).format(format);
      }

      // Dayjs doesn't like .
      const parsedDate = date.replace(/\./g, '');
      const formattedDate = dayjs(parsedDate, ['MMMM D, YYYY, h:mm a', 'MMM DD, YYYY, h:mm a']).tz(dayjs.tz.guess()).format(format);

      return ((formattedDate === 'Invalid Date') ? 'Recently Commented' : formattedDate);
    },
    formatTime(date, format) {
      return dayjs(date).tz(dayjs.tz.guess()).format(format);
    },
  },
};
